import "@styles/index.less";
import {
  admin_routeConfig,
  client_routeConfig,
  routeConfig,
  Routes,
} from "@router";
import Layout from "@components/Layout";
import { useEffect } from "react";
import { cssVars } from "./constants";
import { useLocation } from "react-router-dom";
import Layout2 from "./components/Layout2";
import { useTypedSelector } from "@hooks";
import { fetchCountries } from "@services";
import { useDispatch } from "react-redux";
import { isAdmin } from "./utils";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles.less";

declare global {
  interface Window {
    less: any;
  }
}

const App = () => {
  const dispatch = useDispatch();
  const { countries } = useTypedSelector(state => state.countries);
  const { user } = useTypedSelector(state => state.auth);
  const location = useLocation();

  useEffect(() => {
    if (!countries?.length && user?.id) {
      dispatch(fetchCountries());
    }
  }, [dispatch, countries, user]);
  

  useEffect(() => {
    if (window?.less?.modifyVars) {
      window?.less?.modifyVars(cssVars);
    }
  }, []);

  const paths = ["/", "/login", "/forgot-password", "/reset-password"];
  

  if (!paths.includes(location.pathname)) {
    return (
      <Layout2>
        <Routes
          routes={isAdmin(user?.role!) ? admin_routeConfig : client_routeConfig}
        />
      </Layout2>
    );
  } else {
    return (
      <Layout>
        <Routes
          routes={isAdmin(user?.role!) ? admin_routeConfig : client_routeConfig}
        />
      </Layout>
    );
  }
};

export default App;
